export default __webpack_public_path__ + "static/media/s2-grid1.430ebf11.jpg";